import { Component, OnInit } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { auth } from "firebase/app";
import { AngularFirestore } from "@angular/fire/firestore";
import { Router } from "@angular/router";
import { AuthService } from "../../../service/auth.service";
import { AdministradorDataService } from "../../../service/administrador/administrador-data.service";
import { UserInterface } from "../../../models/user";
import { AlertService } from "ngx-alerts";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  
  public admins: UserInterface[];
  public email: string = "";
  public password: string = "";
  uidUser: any;
  user:any ={};
  data: string;
  admin:boolean=false;

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router,
    public authService: AuthService,
    public dataAdmn: AdministradorDataService,
    private alertService: AlertService,
    public db: AngularFirestore,
  ) {
    this.isLogin();
  }
  
  ngOnInit() {
    
  }
  // getListAdmn () {
  //   this.dataAdmn.getAllAdministradores().subscribe( admins => {
  //     console.log('Admins', admins);
  //    this.admins = admins;
  //  });
  // }

  // onLoginGoogle() {
  //   this.afAuth.auth.signInWithPopup(new auth.GoogleAuthProvider());
  //   this.router.navigate(['admin/list-sucursale']);
  // }

  onLogin(): void {
    this.authService
      .loginEmailUser(this.email.trim(), this.password.trim())
      .then((res) => {
        this.authService.isAuth().subscribe((user) => {
          this.uidUser = user.uid;
          this.db
          .doc(`users/${this.uidUser}`)
          .valueChanges()
          .subscribe((data) => {
            this.user = data;
            if(this.user.tipo === 1 || this.user.tipo === 3 || this.user.tipo === 6){
              this.admin = false;
              this.router.navigate(['admin/home-admin']);
            }else{
              this.logOut();
              this.admin = true;
            }
          });
        });
      })
      .catch((err) => this.alertService.danger(err.message));
  }

  isLogin(){
    this.authService.isAuth().subscribe((user) => {
      if(user){
        this.router.navigate(['admin/home-admin']);
      }
    });
  }
  //  getListAdmn() {
  //  }
  logOut() {
    localStorage.clear();
    this.afAuth.signOut();
  }
}
